import {
  DeviceCategory,
  DeviceItem,
  GetDevicesOfProjectResponse,
  GetMyProductsResponse,
  MyProduct,
  UserCustomItems
} from 'src/model/api/v2/data-contracts';
import { devIsCabinet, devIsCustom } from 'src/components/Planner/planner/uDev';

interface DeviceCategoryLookup {
  categoryToProductNameIds: Record<number, number[]>;
  productNameIdToCategory: Record<number, number>;
}

class DeviceProvider {

  private deviceByProductId: Record<number, DeviceItem> = {};
  private deviceByProductNameId: Record<number, DeviceItem> = {};
  private customDeviceById: Record<number, MyProduct> = {};
  private categories: DeviceCategory[] = [];

  setDevices(devicesResponse: GetDevicesOfProjectResponse, getMyProductsResponse: GetMyProductsResponse) {
    this.deviceByProductId = {};
    this.deviceByProductNameId = {};
    this.customDeviceById = {};
    this.categories = devicesResponse.categories;
    devicesResponse.categories.forEach((category => {
      category.subcategories.forEach((subCategory => {
        subCategory.devices.forEach((device => {
          this.deviceByProductId!![device.product_id] = device;
          this.deviceByProductNameId!![Number(device.id)] = device;
        }));
      }));
    }));

    getMyProductsResponse.products.forEach((product => {
      this.customDeviceById[product.userCustomItem.id] = product;
    }));
  }

  getDeviceByProductId(productId: number): DeviceItem|null {
    return this.deviceByProductId!![productId];
  }
  getDeviceByProductNameId(productNameId: number): DeviceItem|null {
    return this.deviceByProductNameId!![productNameId];
  }

  getDeviceCategoryLookup(): DeviceCategoryLookup {
    const categoryToProductNameIds: Record<number, number[]> = {};
    const productNameIdToCategory: Record<number, number> = {};
    this.categories.forEach(category =>
      category.subcategories.forEach(subcategory => {
        const productNameIds = subcategory.devices.map(device => Number(device.id));
        categoryToProductNameIds[subcategory.id] = productNameIds;
        productNameIds.forEach(productNameId => { productNameIdToCategory[productNameId] = subcategory.id; });
      })
    );
    return { categoryToProductNameIds, productNameIdToCategory };
  }

  getCategoryOfProductNameId(productNameId: number): number | undefined {
    return this.getDeviceCategoryLookup().productNameIdToCategory[productNameId];
  }

  /**
   * @param type 1: rack cabinet, 2: electrical cabinet
   * @returns translated name of the cabinet
   */
  getCabinetName(type: number): string {
    // TODO: moveplannercode implement after handling of cabinets in device tree is implemented
    return '' + type
  }

  getUserCustomItem(id: number): UserCustomItems {
    return this.customDeviceById[id]?.userCustomItem;
  }

  getMyProduct(id: number): MyProduct {
    return this.customDeviceById[id];
  }

  addCustomDevice(myProduct: MyProduct) {
    this.customDeviceById[myProduct.userCustomItem.id] = myProduct;
  }

  getDeviceHelper(dev: any): DeviceItem|UserCustomItems|string|null {

    if (devIsCabinet(dev)) {
      return this.getCabinetName(dev.item_type);
    }
    else if (devIsCustom(dev)) {
      return this.getUserCustomItem(dev.user_custom_item_id)
    }
    else {
      return this.getDeviceByProductNameId(dev.product_name_id);
    }
  }

}

export const deviceProvider = new DeviceProvider();
